import { Box } from "@mui/material";
import styled, { css } from "styled-components";

const commonContainerStyles = css`
  width: 150px;
  height: 150px;
  border-radius: 30px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
`;

export const StyledProfilePhotoContainer = styled(Box)`
  ${commonContainerStyles}
  border: 1px solid #ccc;
`;

export const SkeletonPlaceholder = styled(Box)`
  ${commonContainerStyles}
  background: linear-gradient(90deg, #d0d0d0 0%, #a0a0a0 50%, #d0d0d0 100%);
  background-size: 200% 100%;
  animation: slidePulse 1.5s infinite ease-in-out;
  opacity: 0.9;

  @keyframes slidePulse {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
`;

export const ImagePlaceholder = styled(Box)`
  ${commonContainerStyles}
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  color: #888;
  font-size: 1.4em;
  font-weight: bold;
  text-align: center;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledLargeImage = styled.img`
  width: 600px;
  height: 600px;
  object-fit: cover;
  border-radius: 30px;
`;

export const ModalBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  width: 700px;
  height: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  outline: none;
  transform: translate(-50%, -50%);
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
`;
